export default __webpack_public_path__ + "static/media/podolsk_minskiy.77a27a7e.jpg";